import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { AppStateService } from '../shared/app-state.service';
import { BaseService } from '../shared/base.service';
import * as appAction from '../state/app.actions';
import { AppState } from '../state/app.state';


export class LoginResponse {
  message = '';
  token = '';
  user = new User;
}

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseService {
  currentUser: User;
  redirectUrl = 'home';
  private _isAdmin = false;
  private _isEditor = false;
  isLoggedIn = false;
  isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  token = '';

  constructor(http: HttpClient, messageService: MessageService, appState: AppStateService,
    private router: Router, store: Store<AppState>) {
    super(http, messageService, appState, store);

    if (this.getToken()) {
      this.isLoggedIn = true;
      this.currentUser = Object.assign(new User(), JSON.parse(localStorage.getItem('user')));
      this.store.dispatch(new appAction.ToggleCurrentUser(this.currentUser));
      this.isLoggedIn$.next(this.isLoggedIn);
      this._isAdmin = this.currentUser.roles.some(role =>
        ((role.name === 'superadministrator') || (role.name === 'administrator')));
      this._isEditor = this.currentUser.roles.some(role =>
        role.name === 'editor');
    }

    this.appState.forcedLogOut$.subscribe((status) => {
      if (status) { this.logout(); }
    });
  }

  get isAdmin(): boolean { return this._isAdmin; }
  get isEditor(): boolean { return this._isEditor; }

  login(user, password) {
    const loginUrl = this.apiUrl + '/login';
    this.http.post<LoginResponse>(loginUrl, { 'email': user, 'password': password }, this.httpOptions)
      .subscribe(
        (response) => {
          if (response.message === 'success') {
            this.isLoggedIn = true;
            this.token = response.token;
            this.currentUser = response.user;

            this._isAdmin = response.user.roles.some(role =>
              ((role.name === 'superadministrator') || (role.name === 'administrator')));
            this._isEditor = this.currentUser.roles.some(role =>
              role.name === 'editor');
            this.isLoggedIn$.next(this.isLoggedIn);

            localStorage.setItem('token', this.token);
            localStorage.setItem('user', JSON.stringify(this.currentUser));
            this.router.navigate([this.redirectUrl]);
          }
        },
        (error: HttpErrorResponse) => {
          this.messageService.add({
            severity: 'error',
            summary: 'User login failed!',
            detail: 'Bitte prüfen Sie Emailadresse und Passwort!'
          });
          this.isLoggedIn = false;
          localStorage.removeItem('token');
          this.isLoggedIn$.next(this.isLoggedIn);
        });
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this._isAdmin = false;
    this._isEditor = false;
    this.currentUser = null;
    this.isLoggedIn = false;
    this.isLoggedIn$.next(this.isLoggedIn);
    this.router.navigate(['/']);
  }

}
